<div class=" row mt-3 " style="padding: 10px;">
                         
                          
    <div class="col-md-12 " >
      <div class=" col-md-12 row">
      <mat-form-field class=" col-md-3 mt-1 form-group " >
      <input matInput type="text"     placeholder="Search..." [(ngModel)]="searchText" (input)="searchFilter()" autocomplete="off"   >
      
      </mat-form-field>
      <div class="col-md-1 mt-3 ">
     <div class="col-md-12 d-flex justify-content-end">
        <button  class="btn btn-outline-primary btn-sm " (click)="onAddAirport()">
            <img src="assets/images/Add_24.png"></button>
    </div>
      </div>
      <!-- <mat-paginator  class="col-md-8 mt-2 " style="background-color: transparent;" color="primary"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100]"
      [length]="totalElements"
      (page)="nextPage($event)"
      aria-label="Select page">
      </mat-paginator> -->
      
      </div>
      <div class="col-md-12" style="overflow: auto ;max-height:50vh;">
      <table mat-table 
      [dataSource]="airportData" multiTemplateDataRows style="background-color: transparent;">
     
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Staus</th>
        <td mat-cell *matCellDef="let element"  (click)="rowAirportClick(element)"> 
          <mat-icon *ngIf="element.status==='A'" class='font-16-green-icon'>check_circle</mat-icon>
          <mat-icon *ngIf="element.status==='I'" class='font-16-red-icon'>cancel</mat-icon>
          </td>
      </ng-container>
       <ng-container matColumnDef="name">
         <th mat-header-cell *matHeaderCellDef> Branch Id</th>
         <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowAirportClick(element)"> {{element?.branchCode}} </td>
       </ng-container>
     
      
     
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef>City</th>
        <td mat-cell *matCellDef="let element"> {{element?.city}} </td>
       </ng-container>
       <ng-container matColumnDef="creationTime">
        <th mat-header-cell *matHeaderCellDef>Creation Time</th>
        <td mat-cell *matCellDef="let element"> {{formatDate(element?.genTs)}} </td>
       </ng-container>
       
      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container  matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsAirportsDisplay.length">
      <div class="example-element-detail row"
       [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
      
      </div>
      </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="columnsAirportsDisplay;sticky" style="background-color: white;"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsAirportsDisplay;"
      class="example-element-row">
      </tr>
      <tr  mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      <tr class="mat-row" *matNoDataRow>
      <td  class="mat-cell" colspan="4">There is no data in this table</td>
      </tr>
      </table>
      
    </div>
      </div>
      
  

</div> 

<div class="modal "  id="myMod"  [style.display]="showAirportPopup ? 'block' : 'none'" >
    <div class="modal-dialog" >
        <div class="modal-content " >
            <div class="modal-header title" *ngIf="showAirportPopup">
              <h4 *ngIf="action==='new'"  class="modal-title">Add Branch</h4>
              <h4 *ngIf="action==='update'"  class="modal-title">Edit Branch</h4>


            <!-- <button *ngIf="!selectedFile && action==='new'" type="button" mat-raised-button (click)="fileInput.click()">Select File</button>
            <button *ngIf="selectedFile && action==='new'" type="button" mat-raised-button (click)="fileInput.click()">{{selectedFile?.name}}</button>

            <input    hidden  accept=".xlsx, .xls" (change)="onFileSelected($event)" #fileInput type="file"> 
            <button *ngIf="action==='new'"  class="btn btn-outline-success c-width-100px shadow " (click)="uploadFile()"  [disabled]="!fileSelected">Bulk Upload</button> -->





              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
              </div>
              <div class="modal-body">
              <div class="col-md-12 mt-3 " *ngIf="showAirportPopup">
                <div class="col-md-12 d-flex justify-content-center" >
                <div class="col-md-12 row " >
                    <div class=" col-md-12 " >
                            <form [formGroup]="airportRegFg"   autocomplete="off"  class=" row" >
                                
                               
                                
                                <mat-form-field class="col-md-6" appearance="outline">
                                  <mat-label>Branch Id</mat-label>
                                  
                                  <input matInput type="text" formControlName="branchCode" maxlength="100"  name="name" autocomplete="off">
                                  <small *ngIf="airportRegFg.controls['branchCode'].dirty && airportRegFg.controls['branchCode'].invalid" class="warn">Please Enter branchCode!</small>

                          
                                </mat-form-field>  
                                <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>City</mat-label>
                                    
                                    <input matInput type="text" formControlName="city"  maxlength="100" name="city" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['city'].dirty && airportRegFg.controls['city'].invalid" class="warn">Please Enter City!</small>
  
                            
                                  </mat-form-field>  
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Email</mat-label>
                                    
                                    <input matInput type="text" formControlName="helplineEmail"   name="helplineEmail" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['helplineEmail'].dirty && airportRegFg.controls['helplineEmail'].invalid" class="warn">Please Enter Email!</small>
  
                            
                                  </mat-form-field> 
                                  
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Status</mat-label>
                                    
                                  
   <mat-select  matNativeControl name="status"  formControlName="status"   >
                      <mat-option  value="A" >Active</mat-option>
                      <mat-option  value="I" >Inactive</mat-option>
                    </mat-select>
                            
                                  </mat-form-field>  
                                  <mat-form-field class="col-md-12" appearance="outline">
                                    <mat-label>GST Number</mat-label>
                                    
                                    <input matInput type="text" formControlName="gstNumber" maxlength="20"   name="gstNumber" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['gstNumber'].dirty && airportRegFg.controls['gstNumber'].invalid" class="warn">Please Enter gstNumber!</small>
  
                            
                                  </mat-form-field> 
                                  <mat-form-field class="col-md-12" appearance="outline">
                                    <mat-label>Contact Number (: Separated)</mat-label>
                                    
                                    <input matInput type="text" formControlName="helplineContactNumber" (keypress)="onlyNumberSpecialKey($event)" name="helplineContactNumber" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['helplineContactNumber'].dirty && airportRegFg.controls['helplineContactNumber'].invalid" class="warn">Please Enter Contact Number!</small>
  
                            
                                  </mat-form-field>  
                                  <mat-form-field class="col-md-12" appearance="outline">
                                    <mat-label>Address</mat-label>
                                    
                                    <textarea matInput type="text" formControlName="address"   name="address" autocomplete="off"></textarea>
                                    <small *ngIf="airportRegFg.controls['address'].dirty && airportRegFg.controls['address'].invalid" class="warn">Please Enter Address!</small>
  
                            
                                  </mat-form-field>  
                                  
                                 
                                 
                                
                                

                                </form>
                    </div>
                    </div>
                    </div>                                      
              </div>
                <div class="modal-footer">
                  <div class="form-group form-inline ">
                    <label for="gstlabel" class="col-md-5 col-form-label control-label"> </label>
                  </div>   
                  <button *ngIf="action==='update'"  class="btn btn-outline-success c-width-100px shadow " (click)="updateBranch()" [disabled]="airportRegFg.invalid" >Update</button>

                  <button *ngIf="action==='new'"  class="btn btn-outline-success c-width-100px shadow " (click)="AddAirport()" [disabled]="airportRegFg.invalid" >Save</button>
                  <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                </div>
              </div>
              </div>
      </div>
  </div>